import React, { useEffect } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import HRSection from './components/HRSection';
import Process from './components/Process';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <HRSection />
        <Process />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
